/**
 * 教材
 * 教材API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The TextBookCategoryAndTagForm model module.
   * @module textbook/model/TextBookCategoryAndTagForm
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>TextBookCategoryAndTagForm</code>.
   * @alias module:textbook/model/TextBookCategoryAndTagForm
   * @class
   */
  var exports = function() {
    var _this = this;






  };

  /**
   * Constructs a <code>TextBookCategoryAndTagForm</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:textbook/model/TextBookCategoryAndTagForm} obj Optional instance to populate.
   * @return {module:textbook/model/TextBookCategoryAndTagForm} The populated <code>TextBookCategoryAndTagForm</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'categoryIds')) {
        obj['categoryIds'] = ApiClient.convertToType(data['categoryIds'], ['Integer']);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'tagIds')) {
        obj['tagIds'] = ApiClient.convertToType(data['tagIds'], ['Integer']);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'status')) {
        obj['status'] = ApiClient.convertToType(data['status'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'sortKey')) {
        obj['sortKey'] = ApiClient.convertToType(data['sortKey'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'forSale')) {
        obj['forSale'] = ApiClient.convertToType(data['forSale'], 'Boolean');
      }
    }
    return obj;
  }

  /**
   * 分类ids；字段存在时才更新分类关系（传空数组表示清空，未传表示不修改）
   * @member {Array.<Integer>} categoryIds
   */
  exports.prototype['categoryIds'] = undefined;
  /**
   * 标签id列表；字段存在时才更新标签关系（传空数组表示清空，未传表示不修改）
   * @member {Array.<Integer>} tagIds
   */
  exports.prototype['tagIds'] = undefined;
  /**
   * 状态 0待发布；1上线；2下线
   * @member {Integer} status
   */
  exports.prototype['status'] = undefined;
  /**
   * 排序键（数字越小越靠前）
   * @member {Integer} sortKey
   */
  exports.prototype['sortKey'] = undefined;
  /**
   * 是否开放销售
   * @member {Boolean} forSale
   */
  exports.prototype['forSale'] = undefined;



  export default exports;
;


